import { useEffect, useState } from "react";
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis, CartesianGrid } from "recharts";
import { api, usd } from "@/lib/api";

export const Kpi = ({ label, value, sub, testId, accent }) => (
  <div className="rounded-2xl border border-[#302B28] bg-[#1E1A18] p-6">
    <p className="label-xs text-[#A39E9A]">{label}</p>
    <p className={`mt-3 font-display text-4xl ${accent || ""}`} data-testid={testId}>{value}</p>
    {sub && <p className="mt-1 text-sm text-[#A39E9A]">{sub}</p>}
  </div>
);

const tip = { contentStyle: { background: "#1E1A18", border: "1px solid #302B28", borderRadius: 12, color: "#F9F7F4" }, cursor: { fill: "rgba(255,255,255,.04)" } };

export default function Overview() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/overview").then((r) => setD(r.data)); }, []);
  if (!d) return <p className="text-[#A39E9A]">Loading…</p>;
  return (
    <div data-testid="admin-overview">
      <h1 className="font-display text-3xl font-medium tracking-tight sm:text-4xl">Business at a glance</h1>
      <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <Kpi label="Monthly recurring revenue" value={usd(d.mrr)} sub={`${d.properties} Airbnbs · ${d.checkins} check-ins`} testId="kpi-mrr" accent="text-[#E4A853]" />
        <Kpi label="Paying hosts" value={d.paying} sub={`${d.total_hosts} hosts in total`} testId="kpi-paying" />
        <Kpi label="On free trial" value={d.trial} testId="kpi-trial" />
        <Kpi label="Need attention" value={d.attention} sub="Trial ending or payment overdue" testId="kpi-attention" accent={d.attention ? "text-[#D96C4A]" : ""} />
      </div>
      <div className="mt-6 grid gap-4 lg:grid-cols-12">
        <section className="rounded-2xl border border-[#302B28] bg-[#1E1A18] p-6 lg:col-span-7" data-testid="revenue-chart">
          <h2 className="font-display text-lg">Payments received (USD)</h2>
          <div className="mt-4 h-64"><ResponsiveContainer><BarChart data={d.revenue}><CartesianGrid stroke="#302B28" vertical={false} /><XAxis dataKey="month" stroke="#A39E9A" tickLine={false} axisLine={false} /><YAxis stroke="#A39E9A" tickLine={false} axisLine={false} width={40} /><Tooltip {...tip} /><Bar dataKey="revenue" fill="#D96C4A" radius={[6, 6, 0, 0]} /></BarChart></ResponsiveContainer></div>
        </section>
        <section className="rounded-2xl border border-[#302B28] bg-[#1E1A18] p-6 lg:col-span-5" data-testid="airbnbs-per-host-chart">
          <h2 className="font-display text-lg">Airbnbs per host</h2>
          {d.per_host.length === 0 ? <p className="mt-6 text-sm text-[#A39E9A]">No hosts yet.</p> : (
            <div className="mt-4 h-64"><ResponsiveContainer><BarChart data={d.per_host} layout="vertical"><XAxis type="number" hide allowDecimals={false} /><YAxis type="category" dataKey="name" stroke="#A39E9A" width={140} tickFormatter={(v) => (v.length > 18 ? `${v.slice(0, 17)}…` : v)} tickLine={false} axisLine={false} /><Tooltip {...tip} /><Bar dataKey="properties" fill="#8A9A86" radius={[0, 6, 6, 0]} /></BarChart></ResponsiveContainer></div>
          )}
        </section>
      </div>
    </div>
  );
}
